import { Card } from "reactstrap";
import React, { useEffect, useState } from "react";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";

import AppModal from "../../Common/AppModal";
import "./selectCompany.styles.scss";
import {
  acceptOrDeclineInvitationToJoinCompany,
  getCompanyToUserList,
  getJoinCompanyInvitationList,
  switchCompany,
  switchCompanySuccess,
} from "../../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { isEmpty } from "lodash";
import { HandleDateTimeAgo } from "../../Common/HandleDateTimeAgo";
import CreateNewCompany from "../createNewCompany";
import { toast } from "react-toastify";
export default function SelectCompany({
  modalSelectCompany,
  toggleSelectCompany,
  setModalSelectCompany,
  seeInvitation,
}) {
  const dispatch = useDispatch();

  const [searchQuery, setSearchQuery] = useState("");
  const [searchResult, setSearchResult] = useState([]);
  const [selectedCompanyId, setSelectedCompanyId] = useState(null);
  const [allowedSearchFilters, setAllowedSearchFilters] = useState([
    "Company_BusinessName",
  ]);
  const Local_Company_IdExternal = JSON.parse(localStorage.getItem("authUser"))
    ?.get_user_data?.Company_IdExternal;
  // Redux Store
  const DevRole = JSON.parse(localStorage.getItem("authUser"))?.get_user_data
    ?.User_FlagDeveloper;
  const { companyToUserList } = useSelector((state) => ({
    companyToUserList:
      state.CompanyToUser.companyToUserList?.companytouser_list,
  }));

  const { joinCompanyInvitationList, joinCompanyInvitationListLoading } =
    useSelector((state) => ({
      joinCompanyInvitationList:
        state.CompanyToUser.joinCompanyInvitationList?.userinvitation_list,
      joinCompanyInvitationListLoading:
        state.CompanyToUser.joinCompanyInvitationListLoading,
    }));

  const [companyOrUserProfile, setCompanyOrUserProfile] = useState("company");
  const [refreshPage, setRefresh] = useState(true);

  useEffect(() => {
    let filteredData = companyToUserList;
    if (companyOrUserProfile === "userProfile") {
      if (joinCompanyInvitationList.length === 0) {
        setCompanyOrUserProfile("company");
        return;
      }
      filteredData = joinCompanyInvitationList;
      setAllowedSearchFilters(["Company_BusinessName", "InvitedByUser_Email"]);
    }
    if (companyOrUserProfile === "company") {
      filteredData = companyToUserList;
      setAllowedSearchFilters(["Company_BusinessName"]);
    }
    filteredData = filteredData?.sort((a, b) => {
      return (
        new Date(b?.Company_CreatedDate) - new Date(a?.Company_CreatedDate)
      );
    });
    if (searchQuery) {
      filteredData = filteredData?.filter((item) => {
        return allowedSearchFilters?.some((key) => {
          return (
            item[key] &&
            item[key]
              ?.toString()
              ?.toLowerCase()
              ?.includes(searchQuery?.toLowerCase())
          );
        });
      });
    }
    setSearchResult(filteredData);
  }, [
    searchQuery,
    companyToUserList,
    joinCompanyInvitationList,
    companyOrUserProfile,
  ]);

  useEffect(() => {
    dispatch(getCompanyToUserList());
    dispatch(getJoinCompanyInvitationList());
    if (seeInvitation) {
      setCompanyOrUserProfile("userProfile");
    }
  }, []);

  // Switch Company
  const handleSwitchCompany = (id) => {
    dispatch(switchCompany({ id: id }));
    setSelectedCompanyId(id);
    //reload page
    // window.location.reload();
    // update localStorage
    let authUser = JSON.parse(localStorage.getItem("authUser"));
  };

  const { companySwitchSuccessAPI } = useSelector((state) => ({
    companySwitchSuccessAPI: state.CompanyToUser.companySwitch,
  }));
  console.log("companySwitchSuccessAPI", companySwitchSuccessAPI);
  useEffect(() => {
    if (isEmpty(companySwitchSuccessAPI)) return;
    if (companySwitchSuccessAPI.status === 200) {
      const authUser = JSON.parse(localStorage.getItem("authUser"));
      authUser.token = companySwitchSuccessAPI.token;
      authUser.get_staff_data = companySwitchSuccessAPI.get_staff_data;
      authUser.get_company_data = companySwitchSuccessAPI.get_company_data;
      // Take the company id from the response rather than from component
      // state: the response is what minted the token, so the two can never
      // disagree. get_user_data is defensive - a session snapshot written by an
      // older build may not have it, and throwing here used to abort the whole
      // switch AFTER the token had been fetched but BEFORE it was stored.
      const var___switched_company_id =
        companySwitchSuccessAPI?.get_company_data?.Company_IdExternal ||
        selectedCompanyId;
      if (!authUser.get_user_data) {
        authUser.get_user_data = {};
      }
      authUser.get_user_data.Company_IdExternal = var___switched_company_id;
      authUser.get_securityauthcapability_list =
        companySwitchSuccessAPI.get_securityauthcapability_list;
      authUser.get_securityauthrole_list =
        companySwitchSuccessAPI?.get_securityauthrole_list;
      authUser.get_staffteammembers_list =
        companySwitchSuccessAPI?.get_staffteammembers_list
          ? companySwitchSuccessAPI?.get_staffteammembers_list
          : [];
      // Refresh the per-company config items on switch. The backend returns
      // get_configitem_data for the company being switched into, but if we don't
      // apply it here the timer/etc keep reading the PREVIOUS company's config
      // (e.g. ZCONFIGVAL_14_X default_timer_product), producing "#<staleId>, undefined".
      if (companySwitchSuccessAPI?.get_configitem_data) {
        authUser.get_configitem_data =
          companySwitchSuccessAPI.get_configitem_data;
      }
      // Change #100127 - and its modules. Without this the module-gated tabs
      // (Food Reservation, Pre-Orders, Microsoft 365, Vehicles) kept following
      // the PREVIOUS company. Only applied when the backend sends it, so an
      // older backend leaves the list as it was rather than blanking it.
      if (Array.isArray(companySwitchSuccessAPI?.get_systemmodule_list)) {
        authUser.get_systemmodule_list =
          companySwitchSuccessAPI.get_systemmodule_list;
      }

      // Store the switched session BEFORE anything that can re-render, so no
      // effect can fire a request against the company we have just left.
      localStorage.setItem("authUser", JSON.stringify(authUser));
      setModalSelectCompany(false);
      // redirect to specific page
      if (refreshPage) {
        // replace, not href: the pre-switch page must not stay in history. Its
        // stored session is gone, so going Back would render the old company's
        // screen while every request on it goes to the new company.
        window.location.replace(
          "/" + companySwitchSuccessAPI?.get_staff_data?.OpeningUrl
        );
      }
    } else {
      toast.error(companySwitchSuccessAPI.message);
    }
    dispatch(switchCompanySuccess([]));
  }, [companySwitchSuccessAPI]);

  const [modalCreateNewCompany, setModalCreateNewCompany] = useState(false);
  const toggleCreateNewCompany = () =>
    setModalCreateNewCompany(!modalCreateNewCompany);

  const handleAcceptOrDeclineDecision = (Decision, Id) => {
    const sumUpDecision = {
      Id,
      Decision,
    };
    dispatch(acceptOrDeclineInvitationToJoinCompany([sumUpDecision]));
  };

  const { acceptOrDeclineInvitationToJoinCompanyAPI } = useSelector(
    (state) => ({
      acceptOrDeclineInvitationToJoinCompanyAPI:
        state.CompanyToUser.acceptOrDeclineInvitationToJoinCompany,
    })
  );

  useEffect(() => {
    if (isEmpty(acceptOrDeclineInvitationToJoinCompanyAPI)) return;
    if (acceptOrDeclineInvitationToJoinCompanyAPI.status === 200) {
      dispatch(getJoinCompanyInvitationList());
      dispatch(getCompanyToUserList());
      toast.success(acceptOrDeclineInvitationToJoinCompanyAPI.message);
    } else {
      toast.error(acceptOrDeclineInvitationToJoinCompanyAPI.message);
    }
  }, [acceptOrDeclineInvitationToJoinCompanyAPI]);
  return (
    <>
      {modalCreateNewCompany && (
        <CreateNewCompany
          modal={modalCreateNewCompany}
          setModal={setModalCreateNewCompany}
          toggle={toggleCreateNewCompany}
          createAndSelect={false}
        />
      )}
      {modalSelectCompany && (
        <AppModal
          open={modalSelectCompany}
          onClose={toggleSelectCompany}
          title={
            companyOrUserProfile === "userProfile"
              ? "My Invitations"
              : "Select Company"
          }
          icon={<BusinessOutlinedIcon />}
          headerAccent="indigo"
          size="lg"
          hideFooter
        >
            <div className={"d-flex mb-3"}>
              {companyOrUserProfile === "company" && (
                <div className={"d-flex flex-row justify-content-between"}>
                  <div>
                    <span className="bg-light p-3">Select Company</span>
                    <span
                      className={"btn btn-primary pt-1 pb-1"}
                      onClick={toggleCreateNewCompany}
                    >
                      Add New Business
                    </span>
                  </div>
                  {joinCompanyInvitationList?.length > 0 && (
                    <div className={"ms-2"}>
                      <span
                        className={"btn btn-warning pt-1 pb-1"}
                        onClick={() => {
                          setCompanyOrUserProfile("userProfile");
                        }}
                      >
                        Invitations Pending{" "}
                        <span className={"invitation-pending-number-badge"}>
                          {joinCompanyInvitationList?.length}
                        </span>
                      </span>
                    </div>
                  )}
                </div>
              )}
              {companyOrUserProfile === "userProfile" && (
                <div>
                  {" "}
                  <span className="bg-light p-3">My Invitations</span>
                  <span
                    className={"btn btn-info pt-1 pb-1"}
                    onClick={() => {
                      setCompanyOrUserProfile("company");
                    }}
                  >
                    Select Company
                  </span>
                </div>
              )}
              {DevRole && (
                <div className={"ms-2"}>
                  <button
                    onClick={() => {
                      setRefresh(!refreshPage);
                    }}
                    className={"btn btn-sm btn-dark"}
                  >
                    {refreshPage
                      ? "Refresh the page after switch"
                      : "Dont Refresh Page after switch"}
                  </button>
                </div>
              )}
            </div>
            <div className={"crm_pnp_company_selection_main_container"}>
              <div className={"pb-2"}>
                <input
                  type={"search"}
                  className={"form-control"}
                  placeholder={"Search Company"}
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>
              <div className={""}>
                <div>
                  {companyOrUserProfile === "company" ? (
                    <div>
                      {!isEmpty(companyToUserList) && (
                        <div
                          className={"select-company-card-body-main-wrapper"}
                        >
                          {searchResult?.map((item, index) => (
                            <div key={index}>
                              <Card
                                className={
                                  Local_Company_IdExternal !==
                                  item?.Company_IdExternal
                                    ? "select-company-card-body-container"
                                    : "select-company-card-body-container-selected"
                                }
                                onClick={() =>
                                  Local_Company_IdExternal !==
                                  item?.Company_IdExternal
                                    ? handleSwitchCompany(
                                        item?.Company_IdExternal
                                      )
                                    : null
                                }
                              >
                                <div className="d-flex  align-items-center">
                                  <div
                                    className={
                                      "select-company-container1  d-flex flex-row align-items-center"
                                    }
                                  >
                                    <div
                                      className={"select-company-logo-module"}
                                    >
                                      <div className=" ">
                                        {item?.Company_LogoUrl ? (
                                          <img
                                            src={item?.Company_LogoUrl}
                                            alt="Company Logo"
                                            className="select-company-logo-image"
                                          />
                                        ) : (
                                          <div className="flex-shrink-0 avatar-xs me-2">
                                            <div className="avatar-title bg-soft-success text-success rounded-circle fs-13">
                                              {item?.Company_BusinessName
                                                ? item?.Company_BusinessName.charAt(
                                                    0
                                                  ) +
                                                  item?.Company_BusinessName.split(
                                                    " "
                                                  )
                                                    .slice(-1)
                                                    .toString()
                                                    .charAt(0)
                                                : "Null"}
                                            </div>
                                          </div>
                                        )}
                                        {/*{invoice?.row.original?.Customer_FullName}*/}
                                      </div>
                                    </div>
                                    <div
                                      className={"select-company-text-module"}
                                    >
                                      <div className="flex-grow-1 ms-2">
                                        <h5 className="card-title mb-1">
                                          {item?.Company_BusinessName}{" "}
                                          {item?.CompanyStatus_Name && (
                                            <span
                                              className="badge"
                                              style={{
                                                color:
                                                  item?.CompanyStatus_CssColourText,
                                                backgroundColor:
                                                  item?.CompanyStatus_CssColourBackground,
                                                padding: "5px",
                                                borderRadius: "5px",
                                                fontSize: "10px",
                                              }}
                                            >
                                              {item?.CompanyStatus_Name}
                                            </span>
                                          )}
                                        </h5>
                                        {item?.LastActiveDateTime && (
                                          <div>
                                            <h6 className="mb-1">
                                              Last Active{" "}
                                              <span className="card-text text-muted pb-2">
                                                {" "}
                                                {HandleDateTimeAgo(
                                                  item?.LastActiveDateTime
                                                )}
                                              </span>
                                            </h6>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {DevRole === "1" && (
                                  <div>
                                    {item?.Company_Id && (
                                      <span className={"text-muted"}>
                                        Company Id: {item?.Company_Id}
                                      </span>
                                    )}
                                  </div>
                                )}

                                <button
                                  disabled={
                                    Local_Company_IdExternal ===
                                    item?.Company_IdExternal
                                  }
                                  className="btn btn-primary btn-sm mt-4"
                                >
                                  {Local_Company_IdExternal ===
                                  item?.Company_IdExternal
                                    ? "Selected"
                                    : " Select Company"}
                                </button>
                              </Card>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  ) : (
                    <div>
                      {!isEmpty(joinCompanyInvitationList) && (
                        <div
                          className={"select-company-card-body-main-wrapper"}
                        >
                          {searchResult?.map((item, index) => (
                            <div key={index}>
                              <Card
                                className={
                                  Local_Company_IdExternal !==
                                  item?.Company_IdExternal
                                    ? "select-company-card-body-container"
                                    : "select-company-card-body-container-selected"
                                }
                              >
                                <div className="d-flex mb-4 align-items-center">
                                  <div
                                    className={
                                      "select-company-container1  d-flex flex-row align-items-center"
                                    }
                                  >
                                    <div
                                      className={"select-company-logo-module"}
                                    >
                                      <div className=" ">
                                        {item?.Company_LogoUrl ? (
                                          <img
                                            src={item?.Company_LogoUrl}
                                            alt="Company Logo"
                                            className="select-company-logo-image"
                                          />
                                        ) : (
                                          <div className="flex-shrink-0 avatar-xs me-2">
                                            <div className="avatar-title bg-soft-success text-success rounded-circle fs-13">
                                              {item?.Company_BusinessName
                                                ? item?.Company_BusinessName.charAt(
                                                    0
                                                  ) +
                                                  item?.Company_BusinessName.split(
                                                    " "
                                                  )
                                                    .slice(-1)
                                                    .toString()
                                                    .charAt(0)
                                                : "Null"}
                                            </div>
                                          </div>
                                        )}
                                        {/*{invoice?.row.original?.Customer_FullName}*/}
                                      </div>
                                    </div>
                                    <div
                                      className={"select-company-text-module"}
                                    >
                                      <div className="flex-grow-1 ms-2">
                                        <h5 className="card-title mb-1">
                                          {item?.Company_BusinessName}{" "}
                                          {item?.CompanyStatus_Name && (
                                            <span
                                              className="badge"
                                              style={{
                                                color:
                                                  item?.CompanyStatus_CssColourText,
                                                backgroundColor:
                                                  item?.CompanyStatus_CssColourBackground,
                                                padding: "5px",
                                                borderRadius: "5px",
                                                fontSize: "10px",
                                              }}
                                            >
                                              {item?.CompanyStatus_Name}
                                            </span>
                                          )}
                                        </h5>
                                        {item?.LastLoginDateTime && (
                                          <div>
                                            <h6 className="mb-1">
                                              Last Selected{" "}
                                              <span className="card-text text-muted pb-2">
                                                {" "}
                                                {HandleDateTimeAgo(
                                                  item?.LastLoginDateTime
                                                )}
                                              </span>
                                            </h6>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className={"pb-2"}>
                                  <div>Invitation Sent by:</div>
                                  {item?.InvitedByUser_UserFullName && (
                                    <div>
                                      {item?.InvitedByUser_UserFullName}
                                    </div>
                                  )}
                                  {item?.InvitedByUser_Email && (
                                    <div>{item?.InvitedByUser_Email}</div>
                                  )}
                                </div>
                                <div
                                  className={
                                    "d-flex justify-content-center pb-2"
                                  }
                                >
                                  <div className={"me-2"}>
                                    <button
                                      className={"btn btn-primary"}
                                      onClick={() => {
                                        handleAcceptOrDeclineDecision(
                                          "accepted",
                                          item?.Id
                                        );
                                      }}
                                    >
                                      Accept
                                    </button>
                                  </div>
                                  <div>
                                    <button
                                      className={"btn btn-danger"}
                                      onClick={() => {
                                        handleAcceptOrDeclineDecision(
                                          "rejected",
                                          item?.Id
                                        );
                                      }}
                                    >
                                      Decline
                                    </button>
                                  </div>
                                </div>
                              </Card>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
        </AppModal>
      )}
    </>
  );
}
